import { render, staticRenderFns } from "./editTaskDefinition.vue?vue&type=template&id=2bf15964&"
import script from "./editTaskDefinition.vue?vue&type=script&lang=js&"
export * from "./editTaskDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports